<template>
  <div class="production-date">
    
    <InputGroup
      title="Set Implant Production Date"
      desc="Please set the date for when the implant will be produced."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      >
      <InputDateTime 
        v-model="caseForm.implant_production_date" 
        :darkMode="true"
        mode="date"
        />
    </InputGroup>


    <InputGroup
      title=""
      desc=""
      :skipWhiteBox="true"
      :noLine="true"
      :oneColumn="true"
      :fixedToBottom="true"
      >
      <Button
        label="Save"
        color="green"
        size="large"
        icon="save" 
        @click="submitProductionDate"
        />
    </InputGroup>


  </div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import Button from "@/Components/Button"
import InputDateTime from "@/Components/InputDateTime"

export default {
  props: [
    'thisCase'
  ],
  components: {
    InputGroup,
    InputText,
    Button,
    InputDateTime
  },
  data: () => {
    return {
      caseForm: {
        implant_production_date: '',
      },
    }
  },
  mounted(){
    this.caseForm.implant_production_date = this.thisCase.implant_production_date
  },
  methods: {
    submitProductionDate(){
      this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/production-date`, this.caseForm)
    },
  }
}

</script>

<style scoped lang="sass">

// .production-date



</style>